<template>
	<AddressStaticMap
		:map-img="mapImg"
		:title="title"
		:address="address"
		:lng="lng"
		:lat="lat"
	/>
</template>

<script>
import AddressStaticMap from './AddressStaticMap'

export default {
	name: 'CompanyShenyangMap',
	components: { AddressStaticMap },
	data() {
		return {
			title: '杭州捷途慧声科技有限公司沈阳分公司',
			address: '沈阳市三好街五里河城C1单元801室',
			lng: 123.436421,
			lat: 41.767141,
			mapImg: require('@/assets/img/company/address/shenyang-map.png'),
		}
	},
}
</script>
